"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantSuggestion = instanceOfVariantSuggestion;
exports.VariantSuggestionFromJSON = VariantSuggestionFromJSON;
exports.VariantSuggestionFromJSONTyped = VariantSuggestionFromJSONTyped;
exports.VariantSuggestionToJSON = VariantSuggestionToJSON;
exports.VariantSuggestionToJSONTyped = VariantSuggestionToJSONTyped;
const featureProducedInVariantSuggestion_1 = require("./featureProducedInVariantSuggestion");
const user_1 = require("./user");
const cardUsedInVariantSuggestion_1 = require("./cardUsedInVariantSuggestion");
const templateRequiredInVariantSuggestion_1 = require("./templateRequiredInVariantSuggestion");
const suggestionStatusEnum_1 = require("./suggestionStatusEnum");
/**
 * Check if a given object implements the VariantSuggestion interface.
 */
function instanceOfVariantSuggestion(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('uses' in value) || value['uses'] === undefined)
        return false;
    if (!('requires' in value) || value['requires'] === undefined)
        return false;
    if (!('produces' in value) || value['produces'] === undefined)
        return false;
    if (!('variantOf' in value) || value['variantOf'] === undefined)
        return false;
    if (!('manaNeeded' in value) || value['manaNeeded'] === undefined)
        return false;
    if (!('easyPrerequisites' in value) || value['easyPrerequisites'] === undefined)
        return false;
    if (!('notablePrerequisites' in value) || value['notablePrerequisites'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('spoiler' in value) || value['spoiler'] === undefined)
        return false;
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    if (!('suggestedBy' in value) || value['suggestedBy'] === undefined)
        return false;
    if (!('created' in value) || value['created'] === undefined)
        return false;
    return true;
}
function VariantSuggestionFromJSON(json) {
    return VariantSuggestionFromJSONTyped(json, false);
}
function VariantSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': (0, suggestionStatusEnum_1.SuggestionStatusEnumFromJSON)(json['status']),
        'uses': (json['uses'].map(cardUsedInVariantSuggestion_1.CardUsedInVariantSuggestionFromJSON)),
        'requires': (json['requires'].map(templateRequiredInVariantSuggestion_1.TemplateRequiredInVariantSuggestionFromJSON)),
        'produces': (json['produces'].map(featureProducedInVariantSuggestion_1.FeatureProducedInVariantSuggestionFromJSON)),
        'variantOf': json['variantOf'],
        'manaNeeded': json['manaNeeded'],
        'easyPrerequisites': json['easyPrerequisites'],
        'notablePrerequisites': json['notablePrerequisites'],
        'description': json['description'],
        'spoiler': json['spoiler'],
        'comment': json['comment'],
        'suggestedBy': (0, user_1.UserFromJSON)(json['suggestedBy']),
        'created': (new Date(json['created'])),
    };
}
function VariantSuggestionToJSON(json) {
    return VariantSuggestionToJSONTyped(json, false);
}
function VariantSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uses': (value['uses'].map(cardUsedInVariantSuggestion_1.CardUsedInVariantSuggestionToJSON)),
        'requires': (value['requires'].map(templateRequiredInVariantSuggestion_1.TemplateRequiredInVariantSuggestionToJSON)),
        'produces': (value['produces'].map(featureProducedInVariantSuggestion_1.FeatureProducedInVariantSuggestionToJSON)),
        'variantOf': value['variantOf'],
        'manaNeeded': value['manaNeeded'],
        'easyPrerequisites': value['easyPrerequisites'],
        'notablePrerequisites': value['notablePrerequisites'],
        'description': value['description'],
        'spoiler': value['spoiler'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=variantSuggestion.js.map